import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { checkinReviewReducer } from './checkin-review.reducer';
import { CHECKIN_REVIEW_STORE_NAME, CheckinReviewState } from './checkin-review.state';

/** Token of the CheckinReview reducer */
export const CHECKIN_REVIEW_REDUCER_TOKEN = new InjectionToken<ActionReducer<CheckinReviewState, Action>>(
  'Feature CheckinReview Reducer'
);

/** Provide default reducer for CheckinReview store */
export function getDefaultCheckinReviewReducer() {
  return checkinReviewReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(CHECKIN_REVIEW_STORE_NAME, CHECKIN_REVIEW_REDUCER_TOKEN)],
  providers: [{ provide: CHECKIN_REVIEW_REDUCER_TOKEN, useFactory: getDefaultCheckinReviewReducer }],
})
export class CheckinReviewStoreModule {
  public static forRoot<T extends CheckinReviewState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinReviewStoreModule> {
    return {
      ngModule: CheckinReviewStoreModule,
      providers: [{ provide: CHECKIN_REVIEW_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
